'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _DateInput = _interopRequireDefault(require("Components/Forms/Elements/DateInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Switch = _interopRequireDefault(require("Components/Forms/Elements/Switch"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const CustomTab = (0, _styles.withStyles)(theme => ({
  root: {
    padding: 0,
    minWidth: 'auto',
    fontSize: '0.9em'
  }
}))(props => /*#__PURE__*/_react.default.createElement(_Tab.default, props));
class CvBackForm extends _react.Component {
  state = {
    status_messages: {},
    slug: document.location.pathname.split('liste-des-cvs/')[1],
    'cv[formation]': [],
    'cv[experience]': [],
    current_tab: 0
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchCv();
    }
    component.fetchCandidates();
  }
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-all', {
      candidate_id: state.slug,
      with_count: false
    }).then(function (xhr, response) {
      let update = {};
      update['cv[formation]'] = response.cvs[0]?.formation || [];
      delete response.cvs[0]?.formation;
      update['cv[experience]'] = response.cvs[0]?.experience || [];
      delete response.cvs[0]?.experience;
      update = {
        ...update,
        ...(0, _getStateFromObject.default)({
          data: response.cvs[0],
          model: 'cv'
        })
      };
      component.setState({
        ...update,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCandidates = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        candidates: response.candidates
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const cv = (0, _getFormData.default)({
      state: state,
      pattern: 'cv['
    });
    const url = props.type === 'update' ? '/cv/update' : '/cv/create';
    qwest.post(url, cv).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchCv();
      } else {
        window.setTimeout(function () {
          app.navigateTo('/liste-des-cvs');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleCheckboxChange = _ref => {
    let {
      e,
      name,
      value
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  addFormation = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let formation = state['cv[formation]'];
    formation.push({
      title: '',
      date: '',
      description: '',
      id: id,
      level: '',
      otherlevel: ''
    });
    component.setState({
      'cv[formation]': formation
    });
  };
  deleteFormation = formation_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const formation_filtered = state['cv[formation]'].filter(function (formation) {
      return formation['id'] !== formation_id;
    });
    component.setState({
      'cv[formation]': formation_filtered
    });
  };
  addExperience = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let experience = state['cv[experience]'];
    experience.push({
      title: '',
      start_date: '',
      end_date: '',
      description: '',
      id: id
    });
    component.setState({
      'cv[experience]': experience
    });
  };
  deleteExperience = experience_title => {
    const component = this,
      props = this.props,
      state = this.state;
    const experience_filtered = state['cv[experience]'].filter(function (experience) {
      return experience['id'] !== experience_title;
    });
    component.setState({
      'cv[experience]': experience_filtered
    });
  };
  handleFormationChange = _ref2 => {
    let {
      e,
      value,
      name,
      id,
      field_name
    } = _ref2;
    const component = this,
      props = this.props,
      state = this.state;
    let formation = (state['cv[formation]'] || []).find(formation => formation.id === id);
    formation[field_name] = value;
    component.setState({
      formation: state.formation
    });
  };
  handleExperienceChange = _ref3 => {
    let {
      e,
      value,
      name,
      id,
      field_name
    } = _ref3;
    const component = this,
      props = this.props,
      state = this.state;
    let experience = (state['cv[experience]'] || []).find(experience => experience.id === id);
    experience[field_name] = value;
    component.setState({
      experience: state.experience
    });
  };
  handleCheckboxChange = _ref4 => {
    let {
      e,
      name,
      value
    } = _ref4;
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let formation_list = (state['cv[formation]'] || []).map(function (formation, index) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-background-blue"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: _ref5 => {
          let {
            e,
            value,
            name
          } = _ref5;
          return component.handleFormationChange({
            e,
            name,
            value,
            id: formation.id,
            field_name: 'title'
          });
        },
        value: formation.title,
        name: 'cv[formation][' + index + '][title]',
        type: "text",
        label: "Intitul\xE9 de la formation",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
        onChange: _ref6 => {
          let {
            e,
            value,
            name
          } = _ref6;
          return component.handleFormationChange({
            e,
            name,
            value,
            id: formation.id,
            field_name: 'start_date'
          });
        },
        value: formation.start_date,
        name: 'cv[formation][' + index + '][start_date]',
        label: "Date de d\xE9but",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
        onChange: _ref7 => {
          let {
            e,
            value,
            name
          } = _ref7;
          return component.handleFormationChange({
            e,
            name,
            value,
            id: formation.id,
            field_name: 'end_date'
          });
        },
        value: formation.end_date,
        name: 'cv[formation][' + index + '][end_date]',
        label: "Date de fin",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "title-candidate-form"
      }, "Niveau de la formation :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "CAP",
        onChange: _ref8 => {
          let {
            e
          } = _ref8;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "CAP",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "CAP",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'CAP'
        }
      }), "CAP"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "BAC",
        onChange: _ref9 => {
          let {
            e
          } = _ref9;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "BAC",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "BAC",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'BAC'
        }
      }), "BAC"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Master",
        onChange: _ref10 => {
          let {
            e
          } = _ref10;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "Master",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "Master",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Master'
        }
      }), "Master"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Doctorat",
        onChange: _ref11 => {
          let {
            e
          } = _ref11;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "Doctorat",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "Doctorat",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Doctorat'
        }
      }), "Doctorat"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Formation professionnelle",
        onChange: _ref12 => {
          let {
            e
          } = _ref12;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "Formation professionnelle",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "Formation professionnelle",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Formation professionnelle'
        }
      }), "Formation professionnelle"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Autre",
        onChange: _ref13 => {
          let {
            e
          } = _ref13;
          return component.handleFormationChange({
            e,
            name: 'cv[formation][' + index + '][level]',
            value: "Autre",
            id: formation.id,
            field_name: 'level'
          });
        },
        value: "Autre",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Autre'
        }
      }), "Autre"), state['cv[formation]'][index].level === "Autre" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: _ref14 => {
          let {
            e,
            value,
            name
          } = _ref14;
          return component.handleFormationChange({
            e,
            name,
            value,
            id: formation.id,
            field_name: 'other_level'
          });
        },
        value: formation.other_level,
        name: 'cv[formation][' + index + '][other_level]',
        type: "text",
        label: "Autre niveau",
        status: state.status_messages
      })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: _ref15 => {
          let {
            e,
            value,
            name
          } = _ref15;
          return component.handleFormationChange({
            e,
            name,
            value,
            id: formation.id,
            field_name: 'description'
          });
        },
        value: formation.description,
        name: 'cv[formation][' + index + '][description]',
        label: "Description",
        multiline: true,
        rows: "2",
        "without-headings": true,
        status: state.status_messages
      })), index !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteFormation(formation.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))) : undefined);
      return output;
    });
    let experience_list = (state['cv[experience]'] || []).map(function (experience, index) {
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-background-blue"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: _ref16 => {
          let {
            e,
            value,
            name
          } = _ref16;
          return component.handleExperienceChange({
            e,
            name,
            value,
            id: experience.id,
            field_name: 'title'
          });
        },
        value: experience.title,
        name: 'cv[experience][' + index + '][title]',
        type: "text",
        label: "Titre de mon poste",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: _ref17 => {
          let {
            e,
            value,
            name
          } = _ref17;
          return component.handleExperienceChange({
            e,
            name,
            value,
            id: experience.id,
            field_name: 'company'
          });
        },
        value: experience.company,
        name: 'cv[experience][' + index + '][company]',
        type: "text",
        label: "Employeur",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
        onChange: _ref18 => {
          let {
            e,
            value,
            name
          } = _ref18;
          return component.handleExperienceChange({
            e,
            name,
            value,
            id: experience.id,
            field_name: 'start_date'
          });
        },
        value: experience.start_date,
        name: 'cv[experience][' + index + '][start_date]',
        label: "Date de d\xE9but",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
        onChange: _ref19 => {
          let {
            e,
            value,
            name
          } = _ref19;
          return component.handleExperienceChange({
            e,
            name,
            value,
            id: experience.id,
            field_name: 'end_date'
          });
        },
        value: experience.end_date,
        name: 'cv[experience][' + index + '][end_date]',
        label: "Date de fin",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[experience]'][index].type === "Emploi",
        onChange: _ref20 => {
          let {
            e
          } = _ref20;
          return component.handleExperienceChange({
            e,
            name: 'cv[experience][' + index + '][type]',
            value: "Emploi",
            id: experience.id,
            field_name: 'type'
          });
        },
        value: "Emploi",
        color: "primary",
        name: 'cv[experience][' + index + '][type]',
        inputProps: {
          'aria-label': 'Emploi'
        }
      }), "Emploi"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[experience]'][index].type === "Stage",
        onChange: _ref21 => {
          let {
            e
          } = _ref21;
          return component.handleExperienceChange({
            e,
            name: 'cv[experience][' + index + '][type]',
            value: "Stage",
            id: experience.id,
            field_name: 'type'
          });
        },
        color: "primary",
        value: "Stage",
        name: 'cv[experience][' + index + '][type]',
        inputProps: {
          'aria-label': 'Stage'
        }
      }), "Stage"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: _ref22 => {
          let {
            e,
            value,
            name
          } = _ref22;
          return component.handleExperienceChange({
            e,
            name,
            value,
            id: experience.id,
            field_name: 'description'
          });
        },
        value: experience.description,
        name: 'cv[experience][' + index + '][description]',
        label: "R\xE9sum\xE9 de mes fonctions",
        multiline: true,
        rows: "2",
        "without-headings": true,
        status: state.status_messages
      })), index !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteExperience(experience.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))) : undefined);
      return output;
    });
    let candidate_options = (state.candidates || []).map(function (candidate) {
      let option = {
        value: candidate.id,
        label: candidate.firstname + ' ' + candidate.lastname
      };
      return option;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/candidate/create",
      className: "u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper"
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Informations",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Comp\xE9tences & Int\xE9r\xEAts",
      value: 1
    }), /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Formations",
      value: 2
    }), /*#__PURE__*/_react.default.createElement(CustomTab, {
      label: "Exp\xE9riences",
      value: 3
    }))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 0
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['cv[candidate_id]'],
      name: "cv[candidate_id]",
      label: "Candidat",
      status: state.status_messages,
      options: candidate_options,
      "default-value": candidate_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['cv[title]'],
      name: "cv[title]",
      type: "text",
      label: "Poste recherch\xE9",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[summary]"] || '',
      name: "cv[summary]",
      label: "R\xE9sum\xE9 de mon profil",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Type de contrats :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Alternance",
      name: "cv[searched_contract_type][alternance]",
      value: state['cv[searched_contract_type][alternance]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "CDD",
      name: "cv[searched_contract_type][cdd]",
      value: state['cv[searched_contract_type][cdd]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "CDI",
      name: "cv[searched_contract_type][cdi]",
      value: state['cv[searched_contract_type][cdi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Stage",
      name: "cv[searched_contract_type][stage]",
      value: state['cv[searched_contract_type][stage]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "T\xE9l\xE9travail :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['cv[telecommuting]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "cv[telecommuting]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['cv[telecommuting]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "cv[telecommuting]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['cv[is_public]'] === true,
      name: "cv[is_public]",
      "top-label": "Publi\xE9 sur le web",
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 1
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[expertise_field]"] || '',
      name: "cv[expertise_field]",
      label: "Domaines de comp\xE9tences",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[soft_skills]"] || '',
      name: "cv[soft_skills]",
      label: "Soft skills",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[software_and_language]"] || '',
      name: "cv[software_and_language]",
      label: "Logiciels / Langages informatiques ma\xEEtris\xE9s",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[hobbies]"] || '',
      name: "cv[hobbies]",
      label: "Centre d'int\xE9r\xEAt(s)",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[language]"] || '',
      name: "cv[language]",
      label: "Langues",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, formation_list, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addFormation
    }, "Ajouter une formation")))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 3
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 24,
      classes: props.classes
    }, experience_list, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addExperience
    }, "Ajouter une exp\xE9rience")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer le Cv')), status, loader);
    return output;
  }
}
exports.default = CvBackForm;
